import { render, staticRenderFns } from "./QRPage.vue?vue&type=template&id=685e2282&lang=pug&"
import script from "./QRPage.vue?vue&type=script&lang=js&"
export * from "./QRPage.vue?vue&type=script&lang=js&"
import style0 from "./QRPage.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports